export default __webpack_public_path__ + "static/media/nonfood.4b3389de.jpg";